function changeHeaderStickyHeight() {
  const root = document.querySelector(':root')
  const headerSticky = document.querySelector('[data-header-sticky]')

  if (!headerSticky) return

  if (headerSticky.clientHeight < 130) {
    root.style.setProperty(
      '--header-sticky-height',
      `${headerSticky.clientHeight / 16}rem`,
    )
  }
}

document.addEventListener('DOMContentLoaded', () => {
  changeHeaderStickyHeight()
})
window.addEventListener('resize', () => {
  changeHeaderStickyHeight()
})
